import React from 'react';

import moment from 'moment';

import withIntl from '../../shared/intl-hoc';

function FormattedDate({ intl, date }) {
	return (
		<span>
			{moment(date).format('DD.MM.YYYY')} {intl('at')} <span className='time'>{moment(date).format('HH:mm')}</span>
		</span>
	);
}

export default withIntl(FormattedDate);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/components/formatted-date.js